<button data-track=input.leftNavBtnTracking class="str-category-button str-left-nav-button" on-click("openMobileCatLayer")>
    <ebay-menu-24-icon/>
</button>